import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { motion } from 'framer-motion';
import { ANIMATION_APPEAR } from 'libs/styles/animations';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const LineToolSidebar = (props: Props): JSX.Element => {
    return (
        <motion.div {...ANIMATION_APPEAR}>
            <S_LineToolSidebar className={props.className}>
                <SidebarContent withTopPadding />
            </S_LineToolSidebar>
        </motion.div>
    );
};

const S_LineToolSidebar = styled.div`
    width: 100%;
`;
